/* Atipiná — Persiste CEP entre PDP, cart drawer e cart page +
   Auto-recalcula frete quando cart muda (item removido/quantidade alterada).
   2026-05-23 v2 */

(function(){
  var CEP_KEY = 'atipinaCEP';

  function saveCepFromPDP(){
    var pdpForm = document.querySelector('[data-pdp-cep-form]');
    if (!pdpForm) return;
    pdpForm.addEventListener('submit', function(){
      var input = pdpForm.querySelector('[data-pdp-cep-input]');
      if (!input) return;
      var cep = (input.value || '').replace(/\D/g, '');
      if (cep.length === 8){
        try { localStorage.setItem(CEP_KEY, cep); } catch(err){}
      }
    });
  }

  function getSavedCep(){
    try { return localStorage.getItem(CEP_KEY) || ''; } catch(err){ return ''; }
  }

  function getCurrentCepFromInput(){
    var zipInput = document.querySelector('#address_zip');
    if (!zipInput) return '';
    return (zipInput.value || '').replace(/\D/g, '');
  }

  function autoFillCartZip(){
    var saved = getSavedCep();
    if (!saved || saved.length !== 8) return false;

    var zipInput = document.querySelector('#address_zip');
    if (!zipInput) return false;
    if (zipInput.dataset.atipinaPrefilled === '1') return false;

    var formatted = saved.slice(0,5) + '-' + saved.slice(5);
    zipInput.value = formatted;
    zipInput.dataset.atipinaPrefilled = '1';
    zipInput.dispatchEvent(new Event('input', { bubbles: true }));
    zipInput.dispatchEvent(new Event('change', { bubbles: true }));

    var btn = document.querySelector('.get-rates');
    if (btn && document.querySelector('.cart__items, .drawer__items') && (document.querySelector('[data-cart-total]') || document.querySelector('[data-cart-price-holder]'))){
      setTimeout(function(){
        var summary = btn.closest('details');
        if (summary && !summary.open) summary.open = true;
        btn.click();
      }, 250);
    }
    return true;
  }

  /**
   * Limpa cotações antigas e recalcula se já tem CEP válido.
   * Chamado quando o cart muda (item removido, quantidade alterada).
   */
  function recalculateShipping(){
    var wrapper = document.querySelector('#wrapper-response');
    var ratesEl = document.querySelector('#shipping-rates');
    var feedbackEl = document.querySelector('#shipping-rates-feedback');

    // Limpa cotações antigas (subtotal mudou, valores ficaram defasados)
    if (wrapper) wrapper.innerHTML = '';
    if (ratesEl) ratesEl.innerHTML = '';
    if (feedbackEl) feedbackEl.textContent = '';

    // Re-dispara cálculo se ainda tem CEP no input
    var cep = getCurrentCepFromInput();
    if (cep.length === 8){
      var btn = document.querySelector('.get-rates');
      if (btn){
        // pequeno delay pra cart já ter atualizado o subtotal
        setTimeout(function(){ btn.click(); }, 400);
      }
    }
  }

  /**
   * Wrap fetch pra detectar chamadas que mudam o cart.
   */
  function setupFetchInterceptor(){
    if (window.__atipinaCartFetchWrapped) return;
    window.__atipinaCartFetchWrapped = true;

    var originalFetch = window.fetch;
    window.fetch = function(url, options){
      var promise = originalFetch.apply(this, arguments);
      try {
        var urlStr = '';
        if (typeof url === 'string') urlStr = url;
        else if (url && url.url) urlStr = url.url;
        else if (url && url.toString) urlStr = url.toString();

        if (/\/cart\/(change|update|clear|add)\b/i.test(urlStr)){
          promise.then(function(){
            setTimeout(recalculateShipping, 250);
          }).catch(function(){});
        }
      } catch(e){}
      return promise;
    };
  }

  /**
   * Backup: observa mudanças no subtotal (caso o tema use XHR em vez de fetch)
   */
  function watchCartSubtotal(){
    var subtotalEl = document.querySelector('[data-cart-total]');
    if (!subtotalEl) return;
    var lastValue = subtotalEl.textContent;

    var observer = new MutationObserver(function(){
      var currentValue = subtotalEl.textContent;
      if (currentValue !== lastValue){
        lastValue = currentValue;
        recalculateShipping();
      }
    });
    observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });
  }

  function init(){
    saveCepFromPDP();
    autoFillCartZip();

    setTimeout(autoFillCartZip, 500);
    setTimeout(autoFillCartZip, 1500);

    setupFetchInterceptor();
    setTimeout(watchCartSubtotal, 800);

    document.addEventListener('click', function(e){
      var trigger = e.target.closest('[data-cart-toggle], .header__cart-toggle, .site-header__cart-link, a[href$="/cart"], cart-drawer-button, #cart-icon-bubble');
      if (trigger){
        setTimeout(autoFillCartZip, 400);
        setTimeout(autoFillCartZip, 1200);
      }
    });

    // Custom events disparados por outras partes (toast, etc)
    document.documentElement.addEventListener('cart:updated', function(){ setTimeout(recalculateShipping, 250); });
    document.documentElement.addEventListener('cart:refresh', function(){ setTimeout(recalculateShipping, 250); });

    var observer = new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i++){
        var added = mutations[i].addedNodes;
        if (!added || !added.length) continue;
        for (var j = 0; j < added.length; j++){
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.id === 'address_zip' || (node.querySelector && node.querySelector('#address_zip'))){
            autoFillCartZip();
            watchCartSubtotal();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shipping-calculator:initialized', autoFillCartZip);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
